import { Injectable } from '@angular/core';
//import { translations } from '.';
import { EnvService } from './env.service';
import { PatientTreatment } from '@app/pages/patient-treatment/patient-treatment.page';

@Injectable({
  providedIn: 'root'
})


export class LanguageService {

  str = strings;
  default = 'default';
  locale = 'au';

  constructor(private env: EnvService) {	this.locale = env.LOCALE;	 }
  isset(obj:any) { return (typeof obj !== 'undefined' && obj !== null )? true: false;  }

  // translate to language specification
  translate(label:any, params?:any) 
	{

		var str = '';
    //if object is json and perform to identify data
    if (label != null && typeof label == 'object') 
	  {
	    if (this.isset(label[this.locale])) { str =  label[this.locale]; }
	    else if (this.isset(label['en'])) { str = label['en']; }
	  } 
	  else 
	  {
	    str = label;
    }

		try {
		  if (str.indexOf('%s') > -1)
		  {
			  for (var i = 0; i < params.length; i++) { 
				  str = str.replace("%s", params[i]); 
			  }
		  }
		} catch(e)
		{
			console.log("issue translating label, maybe a regex?");
		}
		return str;
	
  }

}

export const strings = {
	regex: {
		city: { en: /^[a-zA-Z ]+(?:[\s-][a-zA-Z]+)*$/ },
		state_province: { en: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/ },
		zip_postal: { en: /[0-9]/ },
		country: { en: /^[A-Za-z]+(?:[\s-][A-Za-z]+)*$/ },
		account_name: { en: /^[A-Za-z ]+(?:[\s-][A-Za-z ]+)*$/ },
		names: { en: /^[a-zA-Z-' ]*$/ },
	},
	common: {
		process_request: { en: 'Processing request...' },
		logging_in: { en: 'Logging in...' },
		close: { en: 'Close' },
		submit: { en: 'Submit' },
		err_ivform: { en: 'Please complete required form data.' },
		footer_copyright: { en: 'Copyright VetPay. All rights reserved. Australian Credit License number 391975 | Privacy Policy' },
		alert: {
			success: { en: 'Success' },
			error: { en: 'Error' },
			warning: { en: 'Warning' },
			info: { en: 'Information' },
		},
		emailaccount: { en: 'myaccount@vetpay.com.au', nz: 'myaccount@vetpay.com.au' },
		offlineserver: { en: 'Unexpected error, service is not currently available' },
		provided: { en: 'Provided' },
		required: { en: 'Required' },
		upload: { en: 'Upload' }
	},
	menu: {
		patienttreatment: { en: 'Patient Treatment' },
		transaction_history: { en: 'Transaction History' },
		clinic_support: { en: 'Clinic Support' },
		accounts: { en: 'Accounts' },
		logout: { en: 'Sign Out' },
	},
	auth: {
		login: {
			header_title: { en: 'CLINIC PORTAL' },
			header_title_delinquent: { en: 'PAYMENT PORTAL' },
			card_title: { en: 'SIGN IN' },
			login: { en: 'Login', nz: 'Push the button' },
			form_invalid: { en: 'Please enter your email address and/or password!' },
			pin_error: { en: 'Invalid Pin' },
			icon: {
				login: { en: 'paw' },
				signup: { en: 'finger-print' }
			}
		},
		register: {
			title: { en: 'Create/Forgot Password?' },
			html_label_info: { en: "Enter your VetPay account email address and we'll send you an email with a link to enable you to reset your password." },
			form_not_complete: { en: 'Please enter a valid email address.' },
			success_title: { en: 'Email sent!' },
			success_message: { en: 'You have been sent an email with instructions on how to reset your password' },
		},
		reset: {
			title: { en: 'Reset Password' },
			expired_token: { en: 'Service Token has expired / Invalid Token.' },
			reminder: { en: 'Your new password must be different from previously used passwords.' },
			password_updated: { en: 'Password has been updated successfully.' },
			patienttreatment: { en: 'Go to Login Page', nz: 'Go to Login Page', icon: { en: 'paw' } },
			apply: { en: 'Apply', nz: ' Apply', color: { en: 'danger' } },
			description: {
				password: { en: 'Your password must be 8-20 characters long, at least one upper/lower case letter, one digit and one special character.' },
				confirm_password: { en: 'Both passwords must match.' },
				existing_password: { en: 'Provide current password to change your password' },
			},
			error: {
				form_invalid: { en: 'Form incomplete!' },
				password_length: { en: 'Password must have a minimum of 8 characters' },
				password_strength: { en: 'Password is not strong enough. At least one upper/lower case letter, one digit and one special character.' },
				password_notmatch: { en: 'Password does not match' },
			}
		}
	},
	patienttreatment: {
		title: { en: 'Hello %s, welcome to the VetPay Client Portal.' },
		title_delinquent: { en: 'Hello %s, welcome to the VetPay Payment Portal.' },
		titleshort: { en: 'Welcome to the VetPay Client Portal.' },
		subtitle: { en: 'Paying Out Your Account In Full' },
	},
	clinic_support: {
		title: { en: 'Clinic Support' },
		err_amount_zero: { en: 'clinic support!' },
		info_payment: { en: 'clinic support info!' },
		note: { en: 'clinic support note!' },
	},
	transaction_history:{
		title: { en: 'Transaction History' },
		grid_title: { en: 'Transaction History' },
		grid_subtitle: { en: 'View your transaction history' },
	},
	accounts: {
		title: { en: 'Update your Account', nz: 'Update your Account' },
		grid_title: { en: 'My Account' },
		button_label_enabled: { en: 'Change' },
		button_label_disabled: { en: 'Set up' },
		authentications: {
			passkeys: {
				title: { en: 'Set up your VetPay Passkey' },
				page_title: { en: 'Your Passkeys' },
				description_enabled: { en: 'You have already enabled Passkeys for your VetPay Portal account. Click on Change to add another or remove existing Passkeys.' },
				description_disabled: { en: 'You don\'t have any Passkeys enabled for your VetPay Portal account. Passkeys are a faster and more secure way to log in to your online accounts than using passwords. Click on Set Up to secure your account.' },
				setup_page_description_enabled: { en: 'You have already enabled Passkeys for your VetPay Portal account. You can add another or remove existing Passkeys below.' },
				setup_page_description_disabled: { en: 'You don\'t have any Passkeys enabled for your VetPay Portal account. Passkeys are a faster and more secure way to log in to your online accounts than using passwords.' },
				setup_page_enable_button: { en: 'Add my Passkey' },
				setup_page_disable_button: { en: 'Remove my Passkey' },
				confirm_remove_header: 'Remove this passkey?',
				confirm_remove_body: 'You will no longer be able to use the Passkey to sign in. You can create a new Passkey for this device at any time.',
				confirm_remove_cancel_button: 'Cancel',
				confirm_remove_yes_button: 'Remove',
				current_device: { en: ' (Current Device)' },
				default_deviceName: { en: 'Other' },
				label_edit_alert: {
					title: { en: 'Set passkey name' },
					message: { en: 'Set a name to remember your VetPay Passkey.' },
					okText: { en: 'Finish Setup' }
				},
				label_input_alert: {
					title: { en: 'Set passkey name' },
					message: { en: 'Set a name to remember your VetPay Passkey.' },
					okText: { en: 'Finish Setup' }
				},
				error: {
					credential_removal: { en: 'We couldn\'t complete your Passkey removal. Please try again later.' },
					fetching_options: { en: 'An error occurred. Please try again later.' },
					device_verification: { en: 'We couldn\'t verify your device. Please try again later.' },
					verify_registration: { en: 'We couldn\'t complete your Passkey registration. Please try again later.' },
					passkey_removal_lock: { en: 'We couldn\'t complete your request. Please re-login in order to continue.' }
				}
			}
		}
	}
};
